<template>
  <div class="person-center-sub-functions">
    <div
      v-for="(item, index) in getSubFunctionList"
      :key="index"
      @click="itemClick(item)"
      class="person-center-sub-functions-item"
    >
      <img :src="item.img" alt />
      <div slot="title">{{ item.name }}</div>
      <van-icon name="arrow" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "toupatient"
    }
  },
  data() {
    return {
      outpatientList: [
        {
          name: "添加卡片",
          path: "relative-card",
          img: require("@assets/mine_add.png")
        },
        /**{
          name: "三码融合码",
          path: "ecode",
          img: require("@assets/mine_threeqrcode.png")
        },*/
        {
          name: "免责声明",
          path: "disclaimer",
          img: require("@assets/mine_mianze.png")
        }
        /**,
        {
          name: "关于我们",
          path: "about-us",
          img: require("@assets/mine_aboutus.png")
        }*/
      ],
      inpatientList: [
        {
          name: "添加住院号",
          path: "relative-card",
          img: require("@assets/mine_add.png")
        },
        {
          name: "免责声明",
          path: "disclaimer",
          img: require("@assets/mine_mianze.png")
        } /**,
        {
          name: "关于我们",
          path: "about-us",
          img: require("@assets/mine_aboutus.png")
        }*/
      ]
    };
  },
  computed: {
    getSubFunctionList() {
      if (this.type === "inpatient") {
        return this.inpatientList;
      }
      return this.outpatientList;
    }
  },
  methods: {
    itemClick(item) {
      this.$emit("routeToDetail", item);
    }
  }
};
</script>

<style lang="less">
.person-center-sub-functions {
  margin: 5%;

  &-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 3rem;
    margin: 0.5rem 0;
    background: white;
    border-radius: 0.32rem;

    img {
      width: 1rem;
      height: 1rem;
      margin-left: 1rem;
    }
    div {
      margin: 0.94rem;
      font-size: 0.88rem;
    }
    i {
      margin: 0 1rem 0 auto;
    }
  }
}
</style>
